import React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaCar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function FitmentStrip({ fitment, onChangeVehicle, compact = false }) {
  const navigate = useNavigate();
  const { isDark } = useThemeClasses();

  const sizeClass = compact ? 'px-3 py-2.5 text-xs sm:text-sm' : 'px-4 py-3 text-sm';

  const handleTap = () => {
    if (onChangeVehicle) {
      onChangeVehicle();
      return;
    }
    navigate('/vehicle-picker');
  };

  if (!fitment?.hasVehicle) {
    return (
      <button
        type="button"
        onClick={handleTap}
        className={`flex w-full items-center gap-2 rounded-xl border text-left transition-colors ${sizeClass} ${
          isDark
            ? 'border-slate-600 bg-slate-800/80 text-slate-300 hover:border-blue-500/50'
            : 'border-amber-200 bg-amber-50 text-amber-900 hover:border-amber-300'
        }`}
      >
        <FaExclamationTriangle className={`shrink-0 ${isDark ? 'text-amber-400' : 'text-amber-600'}`} />
        <span>Add your vehicle to check fitment</span>
      </button>
    );
  }

  const matches = fitment.matches;
  const label = fitment.vehicleLabel || 'your vehicle';

  return (
    <button
      type="button"
      onClick={handleTap}
      className={`flex w-full items-start gap-2 rounded-xl border text-left transition-colors ${sizeClass} ${
        matches
          ? isDark
            ? 'border-emerald-700/50 bg-emerald-950/40 text-emerald-200 hover:border-emerald-600'
            : 'border-emerald-200 bg-emerald-50 text-emerald-800 hover:border-emerald-300'
          : isDark
            ? 'border-amber-700/50 bg-amber-950/30 text-amber-200 hover:border-amber-600'
            : 'border-amber-200 bg-amber-50 text-amber-900 hover:border-amber-300'
      }`}
    >
      {matches ? (
        <FaCheckCircle className={`mt-0.5 shrink-0 ${isDark ? 'text-emerald-400' : 'text-emerald-600'}`} />
      ) : (
        <FaExclamationTriangle className={`mt-0.5 shrink-0 ${isDark ? 'text-amber-400' : 'text-amber-600'}`} />
      )}
      <span className="min-w-0">
        <span className="flex items-center gap-1 font-semibold">
          <FaCar className="text-[10px] opacity-70" />
          {matches ? 'Fits your vehicle' : 'Fitment check'}
        </span>
        <span className="mt-0.5 block opacity-80">
          {matches ? label : `May not fit ${label} — change vehicle`}
        </span>
      </span>
    </button>
  );
}
